














import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import Parts from "@/components/Money/Parts.vue";
import Categories from "@/components/Money/Categories.vue";
import Icon from "@/components/Icon.vue";
import CustomIcon from "@/components/Money/IconList.vue";
import {moneyType} from "@/views/custom";
import IconList from "@/components/Money/IconList.vue";
import CATEGORY_ICON_NAMES from "@/constants/customTagList";
import CategoryInfo from "@/components/Money/CategoryInfo.vue";


@Component({
  components: {CategoryInfo, IconList, CustomIcon, Icon, Parts, Categories}
})
export default class Add extends Vue {
  iconList = CATEGORY_ICON_NAMES
  categoryIcon = CATEGORY_ICON_NAMES[0]
  categoryName = ''

  get tagList() {
    return this.$store.commit('fetchTags');
  }

  get moneyType() {
    const map = {
      'expense': '支出',
      'income': '收入'
    }
    return map[this.$route.params.type as moneyType]
  }

  save() {
    this.$store.commit('fetchTags')
    const names = this.$store.state.tagList.map((tag: { name: any; }) => tag.name)
    if (this.categoryName.length === 0) {
      this.$warning({
        centered: true,
        title: '标签名不能为空',
        content: '请输入标签名'
      })
    } else if (names.indexOf(this.categoryName) >= 0) {
      this.$warning({
        centered: true,
        title: '标签名重复了',
        content: '请重新输入'
      })
      this.categoryName = ''
    } else {
      this.$store.commit('createTag', {
        svg: this.categoryIcon,
        type: this.$route.params.type as moneyType,
        name: this.categoryName
      })
      this.$message.success({content: '已保存', duration: 1});
      this.categoryName = ''
    }

  }
}
